import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonGrid.module.scss";
import {LibraryLessonCard} from "../cards/library-lesson-card/LibraryLessonCard";
import {
  ISongArrangementCardWithProgress
} from "../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.selector";
import {isDefined} from "../../util/is-type";
import {lessonPageUrlFragment} from "../../config/config";
import { useNavigate } from "react-router-dom";

interface ILibraryLessonGridProps {
  totalSongs?: number;
  totalFilteredSongs?: number;
  songArrangements: ISongArrangementCardWithProgress[];
}

export const LibraryLessonGrid: VoidFunctionComponent<ILibraryLessonGridProps> = ({totalSongs, totalFilteredSongs, songArrangements}) => {
  const navigate = useNavigate();
  return (
    <div className={s.container}>
      {songArrangements.map(
        (cardProps) => {
          const url = `${lessonPageUrlFragment}${cardProps.lessonId}`;
          const onClick = () => navigate(url);
          return <LibraryLessonCard key={`songs-user-library-${cardProps.lessonId}`} {...cardProps} onClick={onClick} />
        })
      }
      {isDefined(totalSongs) && isDefined(totalFilteredSongs) 
        ? <div className={s.songsTally}>Showing {totalFilteredSongs} of {totalSongs}</div>
        : null
      }
    </div>
  );
}
